document.addEventListener('DOMContentLoaded', () => {
    window.gift_collection_list = [];
    document.querySelectorAll('.collection-data-wrapper .collection-data').forEach(item => {
        const gift_products = item.querySelectorAll('.gift_product');
        const products = item.querySelectorAll('.product');
        if (gift_products.length === 0 || products.length === 0) {
            item.remove();
        } else {
            const gift_product_ids = [];
            const product_ids = [];
            for (const gift_product of gift_products) {
                gift_product_ids.push({
                    product: gift_product.getAttribute('product_id'),
                    variant: gift_product.innerHTML
                });
            }
            for (const product of products) {
                product_ids.push(product.innerHTML);
            }
            window.gift_collection_list.push({
                collection_id: item.getAttribute('collection_id'),
                gift_product_ids,
                product_ids
            });
        }
    });

    const fetchCartData = () => {
        console.log('-------- fetch cart data -----------');
        fetch('/cart.json').then(res => res.json()).then(res => {
            console.log(res);
            postMessage({
                flag: 'fetched_cart_data',
                cart: res
            }, '*');
        }).catch(err => {
            console.log(err);
        });
    }
    const addGiftProductTocart = (id) => {
        if (id.length < 1) {
            return;
        }
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: {
                id: id,
                quantity: 1,
                properties: {
                    "__freeGift": "true",
                },
                attributes: {
                    "__freeGift": "true",
                }
            },
            sucess: (res) => {
                window.cart_content_update();
            },
            error: (err) => {
                console.log(err);
            }
        }).then(res => {
            window.cart_content_update();
        });
    }
    const removeGiftProducts = (id) => {
        id.forEach(variant=>{
            $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    updates: {
                        [variant]: 0
                    }
                },
                sucess: (res) => {
                    window.cart_content_update();
                },
                error: (err) => {
                    console.log(err);
                }
            }).then(res => {
                window.cart_content_update();
            });
        });
    }
    const getProductsToAdd = (cartData) => {
        const giftCollectionListInCart = [];
        for (const giftCollection of window.gift_collection_list) {
            for (const product_id of giftCollection.product_ids) {
                let isFind = false;
                for (const cartItem of cartData.items) {
                    if (!cartItem.properties.__freeGift && cartItem.product_id == product_id) {
                        giftCollectionListInCart.push(giftCollection);
                        isFind = true;
                        break;
                    }
                }
                if (isFind) {
                    break;
                }
            }
        }
        const giftProducts = [];
        for (const giftCollectionInCart of giftCollectionListInCart) {
            for (const giftProduct of giftCollectionInCart.gift_product_ids) {
                let isFind = false;
                for (const cartItem of cartData.items) {
                    if (cartItem.properties.__freeGift === 'true' && cartItem.product_id == giftProduct.product) {
                        isFind = true;
                        break;
                    }
                }
                if (!isFind) {
                    console.log(giftProducts.indexOf(giftProduct.variant));
                    if (giftProducts.indexOf(giftProduct.variant) == -1) {
                        giftProducts.push(giftProduct.variant);
                    }
                }
            }
        }
        console.log(giftProducts);
        return giftProducts;
    }
    const getProductsToRemove = (cartData) => {
        const giftCollectionListInCart = [];
        for (const giftCollection of window.gift_collection_list) {
            for (const gift_product_id of giftCollection.gift_product_ids) {
                let isFind = false;
                for (const cartItem of cartData.items) {
                    if (cartItem.properties.__freeGift == 'true' && cartItem.product_id == gift_product_id.product) {
                        giftCollectionListInCart.push(giftCollection);
                        isFind = true;
                        break;
                    }
                }
                if (isFind) {
                    break;
                }
            }
        }
        const productsToRemove = [];
        for (const giftCollectionInCart of giftCollectionListInCart) {
            let isFind = false;
            for (const product_id of giftCollectionInCart.product_ids) {
                for (const cartItem of cartData.items) {
                    if (!cartItem.properties.__freeGift && cartItem.product_id == product_id) {
                        isFind = true;
                        break;
                    }
                }
            }
            if (!isFind) {
                for (const giftProduct of giftCollectionInCart.gift_product_ids) {
                    if (productsToRemove.indexOf(giftProduct.variant) === -1) {
                        productsToRemove.push(giftProduct.variant);
                    }
                }
            }
        }
        console.log(productsToRemove);
        return productsToRemove;
    }
    window.addEventListener('message', (e) => {
        if (e.data.flag === 'fetched_cart_data') {
            addGiftProductTocart(getProductsToAdd(e.data.cart));
            removeGiftProducts(getProductsToRemove(e.data.cart));

        } else if (e.data === 'cart content update') {
            fetchCartData();
        }
    });
    fetchCartData();
});